const Types = {
  FETCH_CACHEPAGES_BEGIN: "cachePages/FETCH_CACHEPAGES_BEGIN",
  FETCH_CACHEPAGES_SUCCESS: "cachePages/FETCH_CACHEPAGES_SUCCESS",
  FETCH_CACHEPAGES_ERROR: "cachePages/FETCH_CACHEPAGES_ERROR",

  SET_CACHEPAGES_FILTERS: "cachePages/SET_CACHEPAGES_FILTERS",

  UPDATE_CACHEPAGES_BEGIN: "cachePages/UPDATE_CACHEPAGES_BEGIN",
  UPDATE_CACHEPAGES_SUCCESS: "cachePages/UPDATE_CACHEPAGES_SUCCESS",
  UPDATE_CACHEPAGES_ERROR: "cachePages/UPDATE_CACHEPAGES_ERROR",
};

export default Types;
